import React from 'react';
import { KpiStatCardProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard/KpiStatCard.types';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';
import {
  StatCardContainer,
  StatCardLabel,
  StatCardValue,
  StatCardChange,
  StatCardSubtitle,
} from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard/KpiStatCard.styled';

function getChangeVariant(changePercentage: number): 'positive' | 'negative' | 'neutral' {
  if (changePercentage > 0) return 'positive';
  if (changePercentage < 0) return 'negative';
  return 'neutral';
}

function formatChangeText(changePercentage: number, comparisonText: string): string {
  const formatted = formatDashboardNumber(changePercentage);
  if (changePercentage > 0) return `+${formatted}% ${comparisonText}`;
  return `${formatted}% ${comparisonText}`;
}

export const KpiStatCard: React.FC<KpiStatCardProps> = ({
  label,
  value,
  changePercentage,
  comparisonText,
  subtitle,
  subtitleVariant,
}) => {
  const showChange = changePercentage !== undefined && comparisonText !== undefined;

  return (
    <StatCardContainer>
      <StatCardLabel>{label}</StatCardLabel>
      <StatCardValue>{value}</StatCardValue>
      {subtitle ? (
        <StatCardSubtitle variant={subtitleVariant}>{subtitle}</StatCardSubtitle>
      ) : (
        <StatCardChange variant={showChange ? getChangeVariant(changePercentage) : 'neutral'}>
          {showChange ? formatChangeText(changePercentage, comparisonText) : ' '}
        </StatCardChange>
      )}
    </StatCardContainer>
  );
};
